import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import styles from 'components/UI/V3/Timeline/Item/TimelineItem.module.scss';
import { Moment } from 'moment-timezone';
import React from 'react';

type TimelineItemProps = {
    icon?: IconProp;
    iconColor?: string;
    iconForegroundColor?: string;
    dateTime: Moment;
    className?: string;
    children?: React.ReactNode;
};

export const TimelineItem: React.FC<TimelineItemProps> = ({
    icon,
    iconColor,
    iconForegroundColor,
    dateTime,
    className,
    children
}) => {
    return (
        <div className={clsx(styles.root, className)}>
            <div className={styles.topRow}>
                {icon && (
                    <div
                        className={styles.icon}
                        style={
                            {
                                '--icon-color': iconColor,
                                '--icon-foreground-color': iconForegroundColor
                            } as React.CSSProperties
                        }
                    >
                        <FontAwesomeIcon icon={icon} />
                    </div>
                )}

                <time
                    dateTime={dateTime.toISOString()}
                    className={styles.time}
                >
                    {dateTime.format('h:mm a')}
                </time>
            </div>

            <div className={styles.body}>
                <div className={styles.lineContainer}>
                    <div className={styles.line}></div>
                </div>

                <div className={styles.contentContainer}>
                    <div className={styles.content}>{children}</div>
                </div>
            </div>
        </div>
    );
};
